import { render, staticRenderFns } from "./PostcodecheckerV4.vue?vue&type=template&id=0af0b422&scoped=true"
import script from "./PostcodecheckerV4.vue?vue&type=script&lang=js"
export * from "./PostcodecheckerV4.vue?vue&type=script&lang=js"
import style0 from "./PostcodecheckerV4.vue?vue&type=style&index=0&id=0af0b422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af0b422",
  null
  
)

export default component.exports